import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid } from './p-ea391b91.js';

const stylesCss = ":host{--bic-icon-size:inherit;display:inline-block;font-size:var(--bic-icon-size)}svg{display:block;width:1em;height:1em;fill:currentColor}:host([data-size='2xl']){--bic-icon-size:var(--bi-icon-2xl) !important}:host([data-size='xl']){--bic-icon-size:var(--bi-icon-xl) !important}:host([data-size='large']){--bic-icon-size:var(--bi-icon-large) !important}:host([data-size='medium']){--bic-icon-size:var(--bi-icon-medium) !important}:host([data-size='small']){--bic-icon-size:var(--bi-icon-small) !important}:host([data-color='inherit']){color:inherit}:host([data-color='primary']){color:#01417b}:host([data-color='gray']){color:#1c1b1b}:host([data-color='black']){color:var(--bi-basic-key)}:host([data-color='white']){color:var(--bi-basic-white)}";
const BiIconCrossStyle0 = stylesCss;

const BiIconCross$1 = /*@__PURE__*/ proxyCustomElement(class BiIconCross extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '98ff4582adc8cf40690451e59c37fbfe0c9e6553', "data-bi-icon": 'true', "data-size": this.size, "data-color": this.color }, h("svg", { key: 'ed15b689f05b09d37d944559a247ab0f5af4a23f', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '83b0f044feca265e44727b737a5c208917ff3724', "fill-rule": 'evenodd', d: 'm12.863 11.502 6.959-6.958 1.06 1.06-6.958 6.96 6.959 6.958-1.061 1.06-6.959-6.958-6.959 6.958-1.06-1.06 6.958-6.959-6.958-6.959 1.06-1.06 6.96 6.958Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconCrossStyle0; }
}, [1, "bi-icon-cross", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-cross"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-cross":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconCross$1);
            }
            break;
    } });
}

const BiIconCross = BiIconCross$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconCross, defineCustomElement };
